import * as React from 'react';
import Modal from 'react-modal';

import Button from 'components/ButtonDeprecated';
// @ts-ignore
import FreeClassLimitsLearnMoreDialog from 'groups/components/FreeClassLimitsLearnMoreDialog';
import GroupAvatar from 'groups/components/GroupAvatar';
import MediaObject from 'components/MediaObject';
import Row from 'components/Row';
import Text from 'components/Text';
import TextWithIcon from 'components/TextWithIcon';

import { GroupRecipient } from 'types/typescript/messagingTypes';

type Props = {
  recipient: GroupRecipient;
};

type State = {
  classLimitsDialogIsOpen: boolean;
};

class LimitedGroupRecipientItem extends React.Component<Props, State> {
  state = {
    classLimitsDialogIsOpen: false,
  };

  openClassLimitsDialog = () => {
    this.setState({ classLimitsDialogIsOpen: true });
  };

  closeClassLimitsDialog = () => {
    this.setState({ classLimitsDialogIsOpen: false });
  };

  render() {
    const { recipient } = this.props;
    const { group } = recipient;
    const groupAvatarProp = {
      groupAvatar: { svg_url: group.groupAvatar.svg_url },
    };

    return (
      <React.Fragment>
        <Modal isOpen={this.state.classLimitsDialogIsOpen}>
          <FreeClassLimitsLearnMoreDialog
            peopleListUrl={`/classes/${group.name}/people`}
            onRequestHide={this.closeClassLimitsDialog}
            uiContext="composer_recipient"
          />
        </Modal>
        <li className="RecipientItem" onClick={this.openClassLimitsDialog}>
          <MediaObject figure="right" center>
            <MediaObject gutter="small" center>
              <GroupAvatar group={groupAvatarProp} size="small" />
              <div>
                <Row size="xxsmall">
                  <Text size="small" element="div" truncate>
                    {group.className}
                  </Text>
                </Row>
                <TextWithIcon color="apple" icon="explanation-circle" iconColor="apple">
                  Announcements are unavailable
                </TextWithIcon>
              </div>
            </MediaObject>
            <Button level="secondary" size="xsmall" data-test="limited-send-functionality-button">
              Learn more
            </Button>
          </MediaObject>
        </li>
      </React.Fragment>
    );
  }
}

export default LimitedGroupRecipientItem;
